import {useFormContext} from "react-hook-form";
import {IconType} from "react-icons";

import {FileInput} from "@/components/fileInput/FileInput.tsx";
import {FormLabel} from "@/components/form/FormLabel.tsx";
import {FormSubtext} from "@/components/formSubtext/FormSubtext.tsx";
import {getFormError} from "@/lib/form/form.utils.ts";
import {FieldProps} from "@/pages/checks/components/form/fields/common.ts";

interface FileInputFieldProps extends FieldProps {
  labelIcon?: IconType;
  buttonLabel?: string;
  fileTypes?: string;
}

export const FileInputField = ({
  name,
  label,
  labelIcon,
  buttonLabel = "Choose File",
  fileTypes,
  className,
  required,
  placeholder = "No file chosen",
  disabled,
  helpText,
  supportLink,
  supportLinkText,
}: FileInputFieldProps) => {
  const {
    register,
    watch,
    formState: {errors},
  } = useFormContext();
  const fieldError = getFormError(name, errors);
  const value = watch(name);

  let fileName = placeholder;
  if (value && value[0]) {
    fileName = value[0].name;
  }

  return (
    <div className={className}>
      <FormLabel required={required} forId={name} icon={labelIcon}>
        {label}
      </FormLabel>
      <FileInput
        id={name}
        fileName={fileName}
        disabled={disabled}
        accept={fileTypes}
        buttonLabel={buttonLabel}
        {...register(name)}
      />
      <FormSubtext
        subText={helpText}
        supportLink={supportLink}
        supportLinkText={supportLinkText}
        error={fieldError?.toString()}
      />
    </div>
  );
};
